module.exports = __webpack_public_path__ + "img/de.98925713.svg";